import { type WorkspaceAgentPanelFloatRect } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentPanelFloatRect';
import { type WorkspaceAgentPanelResizeEdges } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentPanelResizeEdges';
import { clampWorkspaceAgentPanelHeight } from '~/components/v2/components/workspace/workspace-agent-panel/utils/clampWorkspaceAgentPanelHeight';
import { getWorkspaceAgentPanelFloatMaxWidth } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelFloatHorizontalBounds';
import {
  getWorkspaceAgentPanelResizedHeight,
  getWorkspaceAgentPanelResizedWidth,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentPanelResizedWidth';
import { clampWorkspaceAgentPanelWidth } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';
import { WORKSPACE_PANEL_EDGE_PADDING } from '~/constants/panelWidths';

export type GetWorkspaceAgentPanelResizedFloatRectParams = {
  deltaX: number;
  deltaY: number;
  resize: WorkspaceAgentPanelResizeEdges;
  startHeight: number;
  startLeft: number;
  startTop: number;
  startWidth: number;
  viewportHeight: number;
  viewportWidth: number;
};

export const getWorkspaceAgentPanelResizedFloatRect = ({
  deltaX,
  deltaY,
  resize,
  startHeight,
  startLeft,
  startTop,
  startWidth,
  viewportHeight,
  viewportWidth,
}: GetWorkspaceAgentPanelResizedFloatRectParams): WorkspaceAgentPanelFloatRect => {
  const maxWidth = resize.left
    ? startLeft + startWidth - WORKSPACE_PANEL_EDGE_PADDING
    : getWorkspaceAgentPanelFloatMaxWidth(viewportWidth, startLeft);
  const maxHeight = resize.top ? startTop + startHeight : viewportHeight - startTop;
  const width = clampWorkspaceAgentPanelWidth(
    Math.min(maxWidth, getWorkspaceAgentPanelResizedWidth({ deltaX, resize, startWidth })),
    maxWidth,
  );
  const height = clampWorkspaceAgentPanelHeight(
    Math.min(maxHeight, getWorkspaceAgentPanelResizedHeight({ deltaY, resize, startHeight })),
    viewportHeight,
  );

  return {
    height,
    left: resize.left ? startLeft + startWidth - width : startLeft,
    top: resize.top ? startTop + startHeight - height : startTop,
    width,
  };
};
